import React, {Fragment, h} from "preact";
import {Card, CF} from "../../../_common/layout";
import AlertBox from "../../../_common/components/AlertBox/AlertBox";
import UpcomingExams from "./UpcomingExams";
import {AppPage} from "../../../_common/components/app-page";
import {
    getStatusExams,
    setExamSelected,
    setEnrollPacs,
    checkEvauDocumentationStatus,
    getEvauDocumentationStatus,
    getStatusEvauExams, getStatusExamsForEvau
} from '../../../_rx/enrollment/exams/actions/index'
import {connect, useSelector} from "react-redux";
import {t} from '../../../_i18n';
import Tabs from "../components/Tabs";
import {useParams} from "react-router";
import {useEffect, useState} from "preact/hooks";
import {useHistory} from "react-router-dom";
import Sidebar from "./sidebar";
import HistoricalExams from "./historicalExams";
import Loading from "../../../_common/components/loading/Loading";
import ModalCancel from "../components/ModalCancel";
import HeaderExams from '../components/HeaderExams';
import ModalPACs from "../components/ModalPACs";
import DisabledPage from "../../../disabled-page/disabledPage";
import ModalEvau from "../components/ModalEvau";
import {isSpanishUser} from "../../../_common/utils/getLang";

function Exams({studentId, setExamSelected, examsStatus, getStatusExamsForEvau}) {
    const [historyEventsStatus, setHistoryEventsStatus] = useState('next')
    const [sideBar, setSideBar] = useState(false)
    const [showEvauAlert, setShowEvauAlert] = useState(false)
    const [evauState, setEvauState] = useState({documents: [], hasValidatedDocuments: false})
    const [showEvauModal, setShowEvauModal] = useState(false);
    const history = useHistory()
    const {action} = useParams()
    const student_meta = useSelector(state => state.status.student_meta);

    useEffect(() => {
        const loadData = async () => {
            history.push('/examenes');
            const status = await getStatusExamsForEvau(studentId);
            if (shouldCallEvau(status)) {
                await loadEvauDocumentation();
            }
        };

        const shouldCallEvau = (status) => {
            if (!status?.available_evau_file_upload?.lower_open) return false;
            const now = new Date();
            const start = new Date(status.available_evau_file_upload.lower_open);
            const end = new Date(status.available_evau_file_upload.higher_close);
            return now > start && now < end;
        };

        const loadEvauDocumentation = async () => {
            const state = await getEvauDocumentationStatus(studentId);
            if (state.errors?.body?.code === 403 || !isSpanishUser(student_meta?.shop_id)) {
                setShowEvauAlert(false);
            } else {
                setEvauState(state);
                setShowEvauAlert(true);
            }
        };

        loadData().then();
    }, []);

    useEffect(() => {
        (action) ? setSideBar(true) : setSideBar(false)
    }, [action])

    const handleCloseModal = () => {
        history.push('/examenes')
        setSideBar(false)
        setExamSelected(null)
    }

    const handleCloseEvauModal = () => {
        setShowEvauModal(false)
    }

    if (!examsStatus)
        return (
            <CF className="max-width-980">
                <Loading label='Cargando...'/>
            </CF>
        )

    return (
        <CF className="max-width-980">
            <Sidebar visible={sideBar} handleCloseModal={handleCloseModal} historyEventsStatus={historyEventsStatus}/>
            <ModalCancel/>
            <ModalPACs/>
            <HeaderExams/>
            { showEvauAlert &&
                <Fragment>
                    <ModalEvau
                        studentId={studentId}
                        visible={showEvauModal}
                        evauState={evauState}
                        setEvauState={setEvauState}
                        closeModal={handleCloseEvauModal}
                    />
                    <AlertBox type={evauState.hasValidatedDocuments ? 'success' : 'warning'} className="m-bottom">
                        <p>
                            <i className={evauState.hasValidatedDocuments ? 'far fa-check-circle m-r-half' : 'far fa-exclamation-circle m-r-half'}/>
                            {evauState.hasValidatedDocuments ?
                                t('evau_alert_documents_validated')
                                :
                                evauState.documents.length > 0 ?
                                    t('evau_alert_documents_pending_validation')
                                    :
                                    t('evau_alert_banner')
                            }
                            {!evauState.hasValidatedDocuments && evauState.documents.length < 1 &&
                                <span className='m-l-half font-bold t-underline cursor-pointer' onClick={() => setShowEvauModal(true)}>{t('evau_modal_link')}</span>
                            }
                        </p>
                    </AlertBox>
                </Fragment>
            }
            <UpcomingExams provisional_is_next={false}/>
            <div className='m-x2-top'>
                <Tabs onClick={setHistoryEventsStatus}/>
                <HistoricalExams status={historyEventsStatus}/>
            </div>
            {historyEventsStatus === 'next' &&
                <div className='m-top-x4'>
                    <UpcomingExams provisional_is_next={true}/>
                </div>
            }
        </CF>
    )
}


Exams = connect(
    ({auth, enrollmentExams}) => ({
        studentId: auth.loggedUser.id,
        examsStatus: enrollmentExams.examsStatus,
        enrollToCancel: enrollmentExams.enrollToCancel
    }),
    {getStatusExamsForEvau, setExamSelected})(Exams);


export default ({...rest}) => {
    const disabled = false;
    return (
        <AppPage className="max-width">
            {disabled && <DisabledPage/>}
            {!disabled && <Exams {...rest}/>}
        </AppPage>
    );
}
